import styled from '@emotion/styled'
import { memo } from 'react'
import type { StreamType } from '../../../../../types'
import i18n from '../../../../utilities/i18n'
import Info from '../../../Icons/Info'
import { getThemeSpacing } from '../../../styles/appTheme'
import { palette } from '../../../styles/colors'
import Link from '../../Link'

const UpBuyMessageRoot = styled('div')({
    display: 'flex',
    flexFlow: 'column nowrap',
})
const UpBuyMessageLabel = styled('div')({
    paddingBottom: getThemeSpacing(2),
})
const UpBuyMessageTokens = styled('span')({
    paddingLeft: getThemeSpacing(0.5),
})

const showTypeMessage = (showType: StreamType) => {
    if (showType === 'group') return i18n.t('chat.upBuyGroup')
    if (showType === 'private') return i18n.t('chat.upBuyPrivate')
    if (showType === 'voyeur') return i18n.t('chat.upBuyVoyeur')
    return i18n.t('chat.upBuyDefault')
}

const showTypeWikiLink = (showType: StreamType) => {
    const base = 'https://wiki.myfreecams.com/wiki/Instructions_and_Features'
    if (showType === 'group') return `${base}#Group_Shows`
    if (showType === 'private') return `${base}#Private_Shows`
    if (showType === 'voyeur') return `${base}#Spy_.2F_Voyeur`
    return base
}

interface IUpBuyMessage {
    showType: StreamType
}

export const UpBuyMessage = memo((props: IUpBuyMessage) => {
    const { showType } = props
    const message = showTypeMessage(showType)

    return (
        <UpBuyMessageRoot>
            <UpBuyMessageLabel>{message}</UpBuyMessageLabel>
            <div>{i18n.t('chat.addTokensNow')}</div>
            <Link
                href={showTypeWikiLink(showType)}
                css={{
                    color: palette.primary + '!important',
                    paddingTop: getThemeSpacing(2.5),
                    display: 'flex',
                    flexFlow: 'row nowrap',
                    alignItems: 'center',
                }}
            >
                <Info />
                <UpBuyMessageTokens>
                    {i18n.t('chat.spendingTokensOnShows')}
                </UpBuyMessageTokens>
            </Link>
        </UpBuyMessageRoot>
    )
})

export const NotAuthenticatedMessage = memo(() => (
    <UpBuyMessageRoot>
        <UpBuyMessageLabel>
            {i18n.t('chat.youMustBeLoggedInToRequestAShow')}
        </UpBuyMessageLabel>
    </UpBuyMessageRoot>
))
